<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="restaurant-details-section" ref="section">
            <div class="breadcrumbs">
                <b-container fluid>
                    <mobile-gutter>
                        <bread-crumbs :crumbs="breadcrumbs" />
                    </mobile-gutter>
                </b-container>
            </div>

            <b-container>
                <mobile-gutter>
                    <b-row>
                        <b-col
                            v-if="introText"
                            lg="10"
                            offset-lg="1"
                        >
                            <markdown-content class="intro-text" :content="introText" v-test:introText />
                        </b-col>

                        <b-col
                            class="map-column"
                            md="6"
                            lg="5"
                            offset-lg="1"
                        >
                            <restaurant-map
                                :lat="lat"
                                :lng="lng"
                                :address="address"
                            />
                        </b-col>

                        <b-col
                            md="5"
                            lg="4"
                            offset-md="1"
                        >
                            <restaurant-details
                                :title="title"
                                :opening-hours="openingHours"
                                :opening-hours-notice="openingHoursNotice"
                                :address="address"
                                :tel="telephoneNumber"
                                :view-menu-details="viewMenuDetails"
                                :sale-text="saleText"
                            />

                            <restaurant-delivery-providers
                                v-if="deliverooUrl || uberEatsUrl || justEatUrl"
                                :deliveroo-url="deliverooUrl"
                                :uber-eats-url="uberEatsUrl"
                                :just-eat-url="justEatUrl"
                            />
                        </b-col>

                        <b-col
                            lg="10"
                            offset-lg="1"
                        >
                            <div class="facilities">
                                <restaurant-facilities
                                    v-if="facilities.length"
                                    :facilities="facilities"
                                />
                            </div>
                        </b-col>
                    </b-row>
                </mobile-gutter>
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    import RestaurantMap from '../RestaurantMap/RestaurantMap';
    import RestaurantDeliveryProviders from '../RestaurantDeliveryProviders/RestaurantDeliveryProviders';
    import RestaurantDetails from '../RestaurantDetails/RestaurantDetails';
    import BreadCrumbs from '../../atoms/BreadCrumbs/BreadCrumbs.vue';
    import RestaurantFacilities from '../RestaurantFacilities/RestaurantFacilities.vue';
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent.vue';

    export default {
        name: 'restaurant-details-section',

        components: {
            MarkdownContent,
            RestaurantFacilities,
            BreadCrumbs,
            RestaurantDetails,
            RestaurantDeliveryProviders,
            RestaurantMap,
        },

        props: {
            title: {
                type: String,
                required: true,
            },

            breadcrumbs: {
                type: Array,
                default: () => ([]),
            },

            lat: {
                type: [String, Number],
                required: true,
            },

            lng: {
                type: [String, Number],
                required: true,
            },

            address: {
                type: String,
                required: true,
            },

            openingHoursNotice: {
                type: String,
                default: '',
            },

            openingHours: {
                type: Object,
                default: () => ({}),
            },

            facilities: {
                type: Array,
                default: () => ([]),
            },

            telephoneNumber: {
                type: String,
                default: '',
            },

            deliverooUrl: {
                type: String,
                default: '',
            },

            uberEatsUrl: {
                type: String,
                default: '',
            },

            justEatUrl: {
                type: String,
                default: '',
            },

            viewMenuDetails: {
                type: Object,
                default: () => ({}),
            },

            saleText: {
                type: String,
                default: '',
            },

            introText: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-details-section {
        padding: 15px 0 30px;

        @include media-breakpoint-up(md) {
            padding: 25px 0 50px;
        }
    }

    .breadcrumbs {
        @include media-breakpoint-up(md) {
            padding: 0 25px;
        }
    }

    .bread-crumbs {
        margin-bottom: 15px;

        @include media-breakpoint-up(md) {
            margin-bottom: 30px;
        }
    }

    .facilities {
        margin-top: 30px;
    }

    .intro-text {
        text-align: center;
        margin-bottom: 30px;

        @include media-breakpoint-up(md) {
            margin-bottom: 45px;
        }

        ::v-deep h2 {
            font-weight: 600;
            font-size: rem(24px);

            @include media-breakpoint-up(md) {
                font-size: rem(36px);
            }
        }
    }

    .map-column {
        margin-bottom: 24px;

        @include media-breakpoint-up(md) {
            margin-bottom: 0;
        }
    }

    .restaurant-map {
        @include media-breakpoint-up(md) {
            height: 100%;

            ::v-deep .base-map {
                height: 100%;

                .map-container {
                    min-height: 100%;
                }
            }
        }
    }
</style>
